import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";
import { getToken } from "_services/auth";
import { alertaErro } from "components/Alerta";
import { useState } from "react";
import { IExtracaoAtpvs } from "../interfaces/IExtracaoAtpvs";

export function useExtracaoAtpv() {
  const api = AxiosRequest.makeApi(process.env.REACT_APP_MS_IMAGEM_BASE_URL);
  const token = getToken();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  async function extrairAtpvs({ arquivos }: IExtracaoAtpvs) {
    setLoading(true);
    try {
      const formData = new FormData();
      arquivos.forEach((file) => {
        formData.append("arquivos", file);
      });

      const { status, data } = await api.post("/script/atpv/dados", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      const response = new HttpResponse(false, status, data);
      const nomeArquivo = `atpvsExtraidos_${Date.now()}.xlsx`;
      const url = window.URL.createObjectURL(
        new Blob([data], { type: "application/xlsx" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nomeArquivo);
      document.body.appendChild(link);
      link.click();
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro("Não foi possível realizar a extração");
      return response;
    } finally {
      setLoading(false);
    }
  }

  return {
    error,
    setLoading,
    loading,
    extrairAtpvs,
  };
}
